import {
    PRODUCT_CHOOSE_CURRENT_PRO_LNGLIST,
} from './constants';
  
export function chooseCurrentPro_lnglist(modal) {
    return {
      type: PRODUCT_CHOOSE_CURRENT_PRO_LNGLIST,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case PRODUCT_CHOOSE_CURRENT_PRO_LNGLIST:
        return {
          ...state,
          currentPro_lnglist:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/product/redux/chooseCurrentPro_lnglist.js